import { useCallback, useState } from "react";

const useExpand = (): [boolean, (open?: boolean) => void] => {
  const [expanded, setExpanded] = useState<boolean>(false);
  const onExpand = useCallback((open = true) => setExpanded(open), [setExpanded]);

  return [expanded, onExpand];
};

export default useExpand;
